<template>
  <div class="row">
    <app-stock v-for="(stock, index) in stocks" :key="index" :stock="stock"></app-stock>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';
  import Stock from './Stock.vue';

  export default {
    data() {
      return {

      }
    },
    computed: {
      ...mapGetters({
        stocks: 'stockPortfolio',
      })
    },
    components: {
      appStock: Stock,
    },
    // computed: {
    //   stocks() {
    //     return this.$store.getters.stockPortfolio;
    //   }
    // }
  }
</script>



// WEBPACK FOOTER //
// src/components/portfolio/Portfolio.vue